document.addEventListener("DOMContentLoaded", function() {
    (function () {
        const cookieBar = document.querySelector('[data-cookie-bar]')
        if (!cookieBar)
            return

        if (document.cookie.split(";").some((item) => item.includes("cookie_consent=1"))) {
            cookieBar?.parentNode.removeChild(cookieBar)
        } else {
            cookieBar.classList.remove('is-accepted')

            const consentBtn = cookieBar.querySelector('[data-consent-button]')
            consentBtn && consentBtn.addEventListener('click', () => {
                cookieBar.classList.add('is-accepted')
                cookieBar.addEventListener('transitionend', () => {
                    cookieBar?.parentNode.removeChild(cookieBar)

                    const expires = new Date(Date.now() + 365 * 864e5).toUTCString()
                    document.cookie = `cookie_consent=1; expires=${expires}; path=/;`;
                }, { once: true })
            })
        }
    }());
});